import { IAppState } from '../../common/state';

export const getIsBrokerAvailableForBanner = (state: IAppState) =>
  !!state.results?.newbuildingBroker?.availableBrokerFlow;
